import styled from '@emotion/styled';
import React, { SyntheticEvent } from 'react';
import { Text } from '~/shared/components/Text/Text';
import { ImageProps } from '~/shared/components/Image/Image';
import { breakpoints } from '~/theme/breakpoints';
import { Link as LinkType } from '~/lib/data-contract/auto-generated/api-model';
import { Link } from '~/shared/components/Link/Link';

export type TCategoryPickerItem = {
    isActive?: boolean;
    icon?: ImageProps;
    link: LinkType;
    isFirst?: boolean;
    onClick?: null | ((e: SyntheticEvent, value: string) => void);
};

export const Wrapper = styled(Link)<Pick<TCategoryPickerItem, 'isActive' | 'isFirst' | 'onClick'>>(
    ({ theme, isActive, isFirst }) => ({
        backgroundColor: isActive ? theme.colors.black : theme.colors.white,
        display: 'flex',
        alignItems: 'center',
        borderRadius: 24,
        padding: '0px 16px',
        minHeight: '38px',
        marginLeft: isFirst ? theme.space[3] : 0,
        transition: 'all .125s ease-in',
        transitionProperty: 'background-color, border-color',
        border: `1px solid`,
        color: theme.colors.black,
        borderColor: isActive ? theme.colors.black : theme.colors.white,
        [`${Text}`]: {
            color: isActive ? theme.colors.white : theme.colors.black,
            transition: 'color 0.125s ease-in',
            fontWeight: isActive ? theme.fontWeights.medium : theme.fontWeights.light,
        },

        '&:hover, &:focus': {
            backgroundColor: theme.colors.grey10,
            textDecoration: 'none',
            [`${Text}`]: {
                color: theme.colors.black,
            },
        },

        [breakpoints.md]: {
            marginLeft: 0,
        },
    }),
);

export const CategoryPickerItem = ({ isFirst, isActive, link, onClick }: TCategoryPickerItem) => {
    return (
        <Wrapper
            isFirst={isFirst}
            href={link.url}
            isActive={isActive}
            onClick={(e) => onClick && link.title && onClick(e, link.title)}
        >
            <Text variant="bodySmall">{link.title}</Text>
        </Wrapper>
    );
};
